import React from "react";
const items = ["ANCORD · Assessor Credenciado", "Ademicon Novo Hamburgo", "Banco Central · Regulamentado", "R$ 13M+ sob Gestão", "50+ Investidores", "Estratégia · Não Venda", "Sem Juros · Sem Pressão"];
export default function Marquee() {
  const list = [...items, ...items];
  return (
    <div className="border-y border-border bg-background/60 overflow-hidden" data-testid="marquee">
      <div className="flex animate-marquee whitespace-nowrap py-5">
        {list.map((t, i) => (
          <div key={i} className="flex items-center gap-8 pr-8 text-xs tracking-[0.25em] uppercase text-muted-foreground">
            <span>{t}</span><span className="text-primary">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
}
